















































































































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import LiveChatMessage from '../../../api/v2/models/live_chat_message'
import api from '../../../api/v2/api'
import {makeChannel} from '../../../../action_cable/cable'
import LiveChatMessageForm from '../../../api/v2/forms/live_chat_message'
import FileIcon from '../atoms_molecules/FileIcon.vue'
import AttachmentForm from "../../../api/v2/forms/attachment";
import Axios from "axios";
import url_path from "../../../../helpers/url_helper";
import LiveChatParticipant from "../../../api/v2/models/live_chat_participant";

@Component({
  methods: {url_path},
  components: {
    FileIcon
  }
})
export default class LiveChat extends Vue {
  @Prop({default: 'Lesson'}) targetableType: 'Lesson'
  @Prop({required: true}) targetableId: string

  chanel: any = null
  isDragging = false
  messages: LiveChatMessage[] = []
  chatContent: string = ''
  attachments = []
  inProgress: boolean = false
  showParticipantDialog: boolean = false
  totalParticipants: number = 0
  participants: LiveChatParticipant[] = []


  async created() {
    const data = await api.liveChatMessage.index({
      targetableId: this.targetableId,
      targetableType: this.targetableType,
    })
    this.messages = data.messages
    this.totalParticipants = data.participantsCount
    this.scrollToLast()
    this.createChannel()
  }

  async mounted() {
    this.scrollToLast()
    document.getElementById('chat-input').addEventListener('input', this.autoExpandTextarea);
  }

  createChannel() {
    this.chanel = makeChannel(
        'LiveChatChannel',
        async (e) => {
          if (e.message) {
            const message = new LiveChatMessage(e.message)
            this.messages.push(message)
          }

          if (e.participants_count) {
            this.totalParticipants = e.participants_count
          }

          this.scrollToLast()
        },
        () => {
          this.chanel.send({
            action: 'follow',
            data: {
              targetable_id: this.targetableId,
              targetable_type: this.targetableType
            }
          })
        },
    )
  }

  autoExpandTextarea() {
    const textarea = document.getElementById('chat-input') as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height to allow shrink
      textarea.style.height = textarea.scrollHeight + 'px'; // Set height based on scroll height
    }
  }

  getFileName(attachment) {
    return this.getFileNameFromString(attachment.file.name)
  }

  getFileNameFromString(string) {
    return string.replace(/\.[^/.]+$/, "")
  }

  getFileExt(attachment) {
    return this.getFileExtFromString(attachment.file.name)
  }

  getFileExtFromString(string) {
    return string.split('.').pop().toUpperCase()
  }

  addAttachment() {
    (this.$refs.file as HTMLInputElement).click()
  }

  async handleUpload(attachment) {
    const attachmentForm = new AttachmentForm()
    attachmentForm.filename = attachment.file.name

    const attachmentRes = await api.attachment.create(attachmentForm)

    const parseProgress = (progressEvent) => {
      const progressPercentage =
          (progressEvent.loaded / progressEvent.total) * 100;
      if (progressPercentage > 98) {
        attachment.progressPercentage = 98
      } else if (progressPercentage > 5) {
        attachment.progressPercentage = progressPercentage
      }
    }

    const res = await Axios.put(attachmentRes.uploadUrl, attachment.file, {
      headers: {
        'Content-Type': attachment.file.type,
        'Content-Disposition': `attachment; filename=${attachment.file.name}`
      },
      onUploadProgress: parseProgress
    })

    if (res.status === 200) {
      attachment.isUploadCompleted = true
      attachment.serverId = attachmentRes.id
    } else {
      return alert("Error: Upload failed!")
    }
  }

  deleteAttachment(index) {
    this.attachments[index].isDeleted = true
  }

  canSubmit() {
    return this.chatContent.trim() != "" || this.attachments.filter(attachment => !attachment.isDeleted && attachment.isUploadCompleted).length
  }

  handleFileChange() {
    Array.from((this.$refs.file as HTMLInputElement).files).forEach((file) => {
      if (this.attachments.find((attachment) => attachment.file.name === file.name && attachment.file.size === file.size)) {
        return
      }

      const attachment = {
        isDeleted: false,
        isUploadCompleted: false,
        serverId: null,
        progressPercentage: 5,
        file: file as File
      }

      if (/png|jpeg|jpg/.test(attachment.file.type) && (10 * 1024 * 1024 < attachment.file.size)) {
        alert("Limit 10 MB per image.")
        return
      } else if (20 * 1024 * 1024 < attachment.file.size) {
        alert("Limit 20 MB per file.")
        return
      }

      this.attachments.push(attachment)
      this.handleUpload(attachment)
    })
  }

  handleEnterChatForm(e) {
    if (e.keyCode == 13 && !e.shiftKey) {
      e.preventDefault()
      if (this.canSubmit()) this.createMessage()
      return false
    }
  }

  dragover(e) {
    e.preventDefault()
    this.isDragging = true
  }

  dragleave() {
    this.isDragging = false
  }

  drop(e) {
    (this.$refs.file as HTMLInputElement)
        .files = e.dataTransfer.files
    this.handleFileChange()
    this.isDragging = false
    e.preventDefault()
  }

  createMessage() {
    if (!this.canSubmit()) return

    this.inProgress = true
    let input = (document.getElementById('chat-input') as HTMLInputElement)

    const messageForm = new LiveChatMessageForm()
    messageForm.content = input.value
    messageForm.targetableId = parseInt(this.targetableId)
    messageForm.targetableType = this.targetableType
    messageForm.attachmentIds = this.attachments.filter((attachment) =>
        !attachment.isDeleted && attachment.serverId
    ).map((attachment) => attachment.serverId)

    api.liveChatMessage.create(messageForm)
        .then(() => {
          this.chatContent = ''
          this.attachments = []
          setTimeout(() => input.focus(), 200)
          input.style.setProperty("height", "unset")
        })
        .catch(() => {
          alert("Error: Send message failed!")
        })
        .finally(() => {
          this.inProgress = false
        })
  }

  scrollToLast() {
    setTimeout(() => {
      let lastMessage = document.querySelector("#last-message") as HTMLElement
      if (lastMessage) {
        lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' })
      }
    }, 100)
  }

  openUrl(url) {
    window.open(url, "_blank")
  }

  async openParticipants() {
    this.showParticipantDialog = true
    this.participants = await api.liveChatMessage.participants({
      targetableId: this.targetableId,
      targetableType: this.targetableType,
    })
  }
}
